"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Views for the model's workspace-file writes (ADR-129).
 *
 * All four are categorized "create" — the only category in the union that
 * covers "made a change to something durable". It drives the collapsed tool
 * group's summary phrasing ("Created an asset"), which is approximate for a
 * delete but closer than the alternatives.
 */
export const workspaceFilesToolRegistry = {
  writeWorkspaceFile: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./file-card").then(({ WriteWorkspaceFileToolView }) => ({
        default: WriteWorkspaceFileToolView,
      }))
    ),
  },
  deleteWorkspaceFile: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./file-card").then(({ DeleteWorkspaceFileToolView }) => ({
        default: DeleteWorkspaceFileToolView,
      }))
    ),
  },
  moveWorkspaceFile: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./file-card").then(({ MoveWorkspaceFileToolView }) => ({
        default: MoveWorkspaceFileToolView,
      }))
    ),
  },
  createWorkspaceFolder: {
    kind: "step",
    category: "create",
    view: lazy(() =>
      import("./file-card").then(({ CreateWorkspaceFolderToolView }) => ({
        default: CreateWorkspaceFolderToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
